interface Data {
  [key: string]: any;
}

interface Labels {
  app: string;
  version?: string;
}

interface LabelSelectorRequirements {
  key: string;
  operator: string;
  values: Array<string>;
}

interface ObjectMetaData {
  labels?: Labels;
  namespace?: string;
  name?: string;
  annotations?: Data;
  generation?: number;
  generateName?: string;
  deletionTimestamp?: string;
  deletionGracePeriodSeconds?: number;
  creationTimestamp?: string;
  clusterName?: string;
}
interface PodSpec {
  activeDeadlineSeconds?: number;
  automountServiceAccountToken?: boolean;
  containers: Array<Container>;
  dnsPolicy?: string;
  enableServiceLinks?: boolean;
  hostIPC?: boolean;
  hostNetwork?: boolean;
  hostPID?: boolean;
  hostname?: string;
  imagePullSecrets: Array<{ name: "" }> | null;
  initContainers: Array<Container>;
  nodeName?: string;
  // nodeSelector?: Data;
  preemptionPolicy?: string;
  priority?: number;
  priorityClassName?: string;
  restartPolicy: "Always" | "OnFailure" | "Never";

  runtimeClassName?: string;
  schedulerName?: string;
  serviceAccount: string;
  serviceAccountName?: string;
  shareProcessNamespace?: boolean;
  subdomain?: string;
  terminationGracePeriodSeconds?: number;
  volumes: Array<Volumn>;
}
interface CronJob {
  // 定时任务
  concurrencyPolicy: string;
  metadata: ObjectMetaData;
  schedule: string;
  startingDeadlineSeconds: number;
  failedJobsHistoryLimit: number;
  successfulJobsHistoryLimit: number;
}
interface JobSpec {
  activeDeadlineSeconds: number;
  ttlSecondsAfterFinished?: number;
  backoffLimit: number;
  completions: number;
  manualSelector?: boolean;
  parallelism: number;
  selector?: {
    matchLabels: Data;
    matchExpressions: Array<LabelSelectorRequirements>;
  };
  template: {
    metadata: ObjectMetaData;
    spec: PodSpec;
  };
  volumeClaimTemplates?: Array<Templete>;
}

interface JobCondition {
  lastProbeTime?: string;
  lastTransitionTime?: string;
  message?: string;
  reason?: string;
  status: string;
  type: string;
}
interface Status {
  active: number;
  conditions: Array<JobCondition>;
  failed: number;
  startTime: string;
  succeeded: number;
}

interface Port {
  name: string;
  protocol: "TCP" | "UDP";
  containerPort: number | undefined;
  servicePort?: number | undefined;
}

export interface Mount {
  name: string;
  readOnly: boolean;
  mountPath: string;
  subPath: string;
}

interface Env {
  name: string;
  value?: string;
  valueFrom?: {
    configMapKeyRef?: {
      key: string;
      name: string;
    };
    secretKeyRef?: {
      key: string;
      name: string;
    };
  };
}
export interface Container {
  name: string;
  imagePullPolicy: "IfNotPresent" | "Always" | "Never";
  type?: string;
  command?: Array<string>;
  image: string;
  ports?: Array<Port>;
  volumeMounts: Array<Mount>;
  env: Array<Env>;
  resources: {
    requests: {
      cpu: string;
      memory: string;
    };
    limits: {
      cpu: string;
      memory: string;
    };
  };
}
export interface Volumn extends Data {
  name: string;
  persistentVolumeClaim?: {
    claimName: string;
  };
  emptyDir?: {};
  secret?: {
    secretName: string;
    items: Array<Data>;
  };
  configMap?: {
    name?: string;
    items?: Array<Data>;
  };
}
export interface Templete extends Data {
  spec: {
    resources: {
      requests: {
        storage: string;
      };
    };
    storageClassName: string;
    accessModes: [string];
  };
  metadata: {
    name: string;
    namespace: string;
  };
}
type kind = "Job" | "CronJob";
type apiVersion = "batch/v1" | "batch/v1beta1";
export interface CreateTaskData {
  apiVersion: apiVersion;
  kind: kind;
  metadata: ObjectMetaData;
  spec: JobSpec;
  status?: Status; // 任务状态，创建时没有，返回时才有
  cronJob: CronJob;
}

export const KindOptions: Array<{ label: kind; value: string }> = [
  { label: "Job", value: "普通任务" }
];
export const protocol = ["TCP", "UDP"];

export const imagePullPolicy = [
  { label: "优先使用本地镜像", value: "IfNotPresent" },
  { label: "尝试重新下载镜像", value: "Always" },
  { label: "仅使用本地镜像", value: "Never" }
];
export const CreateJobForm: CreateTaskData = {
  apiVersion: "batch/v1",
  kind: "Job",
  metadata: {
    namespace: "app-manager",
    labels: {
      app: ""
    },
    name: "", // 任务名
    annotations: {
      description: "" // 任务描述
    }
  },
  spec: {
    template: {
      metadata: {
        labels: {
          app: "" // 任务名
        },
        annotations: {
        }
      },
      spec: {
        containers: [],
        restartPolicy: "Never", // 重启策略
        serviceAccount: "default",
        initContainers: [],
        imagePullSecrets: [],
        volumes: []
        // nodeSelector: {
        //   key: "val"
        // }
      }
    },
    volumeClaimTemplates: [],
    backoffLimit: 2, // 最大重试次数
    completions: 1, // 完成数
    parallelism: 1, // 并行数
    activeDeadlineSeconds: 180, // 退出超时时限(秒)
    ttlSecondsAfterFinished: 600
  },
  cronJob: {
    // 定时任务
    metadata: { labels: { app: "cronjob-test" } },
    concurrencyPolicy: "Forbid",
    schedule: "0 0 * * *",
    startingDeadlineSeconds: 100,
    failedJobsHistoryLimit: 1,
    successfulJobsHistoryLimit: 3
  }
};
